import * as React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

class Snackbar extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      open: this.props.open,
    }
  }

  componentWillReceiveProps(props) {
    this.setState({ open: props.open })
  }

  render() {
    return (
      <Wrapper className={`${this.state.open ? 'show' : ''} ${this.props.position}`} style={{ ...this.props.style }}>
        <div className={`${this.props.icon ? 'icon' : ''}`}>{this.props.icon}</div>
        <div>{this.props.message}</div>
        <div className={`${this.props.action ? 'action' : ''}`}>{this.props.action}</div>
      </Wrapper>
    )
  }
}

Snackbar.defaultProps = {
  message: '',
  open: false,
  position: 'bottom right',
}

Snackbar.propTypes = {
  message: PropTypes.string.isRequired,
  open: PropTypes.bool,
  icon: PropTypes.node,
  action: PropTypes.node,
  position: PropTypes.string,
  style: PropTypes.object,
}

const Wrapper = styled.div`
    display: none;
    justify-content: space-between;
    align-items: center;
    margin: 0;
    text-align: center;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.16);
    font-size: 13px;
    color: #FFFFFF;
    background: #181819;
    border-radius: 2px;
    padding: 6px 24px;
    position: fixed;
    z-index: 1000;

    &.show {
        display: flex;
    }

    & .icon {
        maxHeight: 24px;
        margin-right: 15px;
    }

    & .action {
        maxHeight: 24px;
        margin-left: 15px;
    }

    &.bottom {
        bottom: 10px;
    }

    &.top {
        top: 10px;
    }

    &.center {
        left: 50%;
        transform: translateX(-50%);
    }

    &.right {
        right: 10px;
    }

    &.left {
        left: 10px;
    }
`
export default Snackbar;



// WEBPACK FOOTER //
// ./src/components/Parts/Snackbar.jsx